import React, { useEffect, useState } from "react";
import MainLayount from "../common/MainLayout";
import classes from "./vatmain.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  actionAddEditTranslationApiCall,
  actionUpdateVatData,
} from "../../Redux/Actions";
import Loader from "../common/Loader";
import VatHeader from "../common/VatHeader";

const VatMain = () => {
  const saveVatData = useSelector((state) => state.CommonReducer?.saveVatData);
  const loader = useSelector((state) => state.CommonReducer.loader);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [id, setId] = useState();
  const [percentage, setPercentage] = useState();

  const onClickOfUpdate = (id, name) => {
    const stringData = {
      name: name,
      percentage: percentage,
    };
    let data = JSON.stringify(stringData);

    dispatch(
      actionUpdateVatData({
        data,
        edit: id,
        navigate,
      })
    );
  };
  return (
    <React.Fragment>
      <MainLayount>
        <div className={classes.LanguageMain}>
          <VatHeader />
          <div className={classes.LanguageListingSection}>
            <table>
              {loader == true ? (
                <tr>
                  <td className={classes.LoaderWrap} colSpan={3}>
                    <Loader />
                  </td>
                </tr>
              ) : (
                <>
                  {saveVatData && saveVatData?.length > 0 ? (
                    saveVatData?.map((itme) => (
                      <tr>
                        <td style={{ maxWidth: "250px" }}>{itme.name}</td>
                        <td style={{ maxWidth: "250px" }}>
                          <div className={classes.fildBox}>
                            <textarea
                              placeholder={`${t("name_p")}...`}
                              value={
                                id == itme.id ? percentage : itme.percentage
                              }
                              onChange={(e) => {
                                setPercentage(e.target.value);
                                setId(itme.id);
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <button
                            onClick={() => onClickOfUpdate(itme.id, itme.name)}
                          >
                            {t("update")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className={classes.LoaderWrap} colSpan={3}>
                        <h2>{t("no_data_found")}</h2>
                      </td>
                    </tr>
                  )}
                </>
              )}
            </table>
          </div>
        </div>
      </MainLayount>
    </React.Fragment>
  );
};

export default VatMain;
